/**
 * Prevents Angular change detection from
 * running with certain Web Component callbacks
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
;(window as any).__Zone_disable_customElements = true
